import { format } from 'date-fns'
import { CalendarClock } from 'lucide-react'
import { useUnitAvailabilitySuspenseQuery } from '@/api/accommodation/hooks'
import type { AccommodationDetail } from '@/api/accommodation/types'
import { cn } from '@/lib/utils'
import { getDateSelectionWindow } from './dateSelectionWindow'

interface LastMinuteOfferBannerProps {
  accommodation: AccommodationDetail
  className?: string
}

// Shows the real end of the location's availability (the last selectable
// departure day in the calendar), not the theoretical offer window.
export function LastMinuteOfferBanner({ accommodation, className }: LastMinuteOfferBannerProps) {
  const { data: availabilityData } = useUnitAvailabilitySuspenseQuery(accommodation.unit.id)
  const availabilityWindow = getDateSelectionWindow(availabilityData)
  if (!availabilityWindow) return null

  return (
    <div
      className={cn(
        'flex items-center justify-center gap-2 rounded-lg bg-red-50 px-3 py-2.5 text-sm font-medium text-red-700',
        className,
      )}
    >
      <CalendarClock className="h-4 w-4 shrink-0" />
      <span>
        Last-minute nabídka jen do <span className="font-bold">{format(availabilityWindow.lastDay, 'd. M.')}</span>
      </span>
    </div>
  )
}
